@let entry = entrySg();
@let respondent = respondentSg();
@let formattedDate = formattedDateSg();

<div class="atn-summit-check-ins-entry">
  <div class="atn-summit-check-ins-entry__header">
    <div class="atn-summit-check-ins-entry__respondent">
      {{ respondent }}
    </div>
    <div
      class="atn-summit-check-ins-entry__date"
      (click)="store.toggleDateFormat()"
    >
      {{ formattedDate }}
    </div>
  </div>

  <div class="atn-summit-check-ins-entry__body">
    <div class="atn-summit-check-ins-entry__mood">
      {{ entry.mood }}
    </div>
    <div class="atn-summit-check-ins-entry__content">
      @if (entry.prompt) {
        <h6 class="atn-summit-check-ins-entry__prompt">
          {{ entry.prompt }}
        </h6>
      }
      <p class="atn-summit-check-ins-entry__response">
        {{ entry.response }}
      </p>
    </div>
  </div>
</div>
